export { default } from './Footer1';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Footer/Footer1/index.js